import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import SettingsModal, { SETTINGS_BILLING_TAB_INDEX } from '../molecules/SettingsModal'
import { forgetBillingSettingsLink, hasRememberedBillingSettingsLink, isBillingSettingsLink } from './billingSettingsLink'

// The subscription acknowledgment email links ?settings=billing so subscribers land on Manage subscription. A link
// opened while signed out is remembered on page load (see billingSettingsLink) and opens Billing after sign-in.
const BillingSettingsLinkHandler = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        const isLink = isBillingSettingsLink(location.search)
        if (!isLink && !hasRememberedBillingSettingsLink()) return
        setIsOpen(true)
        if (!isLink) return
        const searchParams = new URLSearchParams(location.search)
        searchParams.delete('settings')
        const search = searchParams.toString()
        navigate(
            { pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash },
            { replace: true }
        )
    }, [location.hash, location.pathname, location.search, navigate])

    // mounted only for the link, so pages that never open it do not run Settings' queries
    if (!isOpen) return null
    const setIsModalOpen = (isModalOpen: boolean) => {
        if (!isModalOpen) forgetBillingSettingsLink()
        setIsOpen(isModalOpen)
    }
    return <SettingsModal isOpen={isOpen} setIsOpen={setIsModalOpen} defaultTabIndex={SETTINGS_BILLING_TAB_INDEX} />
}

export default BillingSettingsLinkHandler
